import { render, staticRenderFns } from "./OrdersFilters.vue?vue&type=template&id=2a53da76&scoped=true&"
import script from "./OrdersFilters.vue?vue&type=script&lang=ts&"
export * from "./OrdersFilters.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersFilters.vue?vue&type=style&index=0&id=2a53da76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53da76",
  null
  
)

export default component.exports